import { render, staticRenderFns } from "./CompanyListView.vue?vue&type=template&id=42606624"
import script from "./CompanyListView.vue?vue&type=script&lang=js"
export * from "./CompanyListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42606624')) {
      api.createRecord('42606624', component.options)
    } else {
      api.reload('42606624', component.options)
    }
    module.hot.accept("./CompanyListView.vue?vue&type=template&id=42606624", function () {
      api.rerender('42606624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/CompanyListView.vue"
export default component.exports